const initialState = {
  classes: [],
  subjects: [],
  topics: [],
  subtopics: [],
  testTypes: [],
  loading: false,
}

const academicReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CLASSES':
      return { ...state, classes: action.payload }
    case 'SET_SUBJECTS':
      return { ...state, subjects: action.payload }
    case 'SET_TOPICS':
      return { ...state, topics: action.payload }
    case 'SET_SUBTOPICS':
      return { ...state, subtopics: action.payload }
    case 'SET_TEST_TYPES':
      return { ...state, testTypes: action.payload }
    default:
      return state
  }
}

export default academicReducer
